import { Locale } from 'modules/i18n';

export const networkUsageCardTranslation = {
  [Locale.en]: {
    noDataAvailable: 'No data available',
  },
};
